var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublicEndowment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Mosque_-_Flaticon-2",
    "data-name": "Search results for Mosque - Flaticon-2",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_234856472",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_186267312",
    d: "M.909.857H70.754a.739.739,0,0,1,.734.743V43.46a.739.739,0,0,1-.734.743H.909a.739.739,0,0,1-.734-.743V1.6A.739.739,0,0,1,.909.857ZM70.02,2.344H1.643V42.717H70.02Z",
    transform: "translate(9.668 45.302)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186267312_-_Outline",
    "data-name": "_186267312 - Outline",
    d: "M.9.357H70.754a1.232,1.232,0,0,1,1.222,1.238V43.454a1.232,1.232,0,0,1-1.222,1.238H.9A1.232,1.232,0,0,1-.324,43.454V1.595A1.232,1.232,0,0,1,.9.357ZM70.754,43.7A.248.248,0,0,0,71,43.454V1.595a.248.248,0,0,0-.246-.249H.9a.248.248,0,0,0-.246.249V43.454A.248.248,0,0,0,.9,43.7ZM1.144,1.844H70.508V43.206H1.144Zm68.388.989H2.12V42.217H69.532Z",
    transform: "translate(9.674 45.308)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186267240",
    d: "M1.108.768H49.4a.737.737,0,0,1,.73.743V6.268a.737.737,0,0,1-.73.743H1.108a.737.737,0,0,1-.73-.743V1.511a.737.737,0,0,1,.73-.743ZM48.675,2.255H1.838v3.27H48.675Z",
    transform: "translate(20.244 40.635)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186267240_-_Outline",
    "data-name": "_186267240 - Outline",
    d: "M1.094.268H49.408a1.229,1.229,0,0,1,1.216,1.238V6.263A1.228,1.228,0,0,1,49.408,7.5H1.094A1.229,1.229,0,0,1-.122,6.263V1.506A1.229,1.229,0,0,1,1.094.268ZM49.408,6.511a.247.247,0,0,0,.244-.249V1.506a.247.247,0,0,0-.244-.249H1.094a.247.247,0,0,0-.245.249V6.263a.247.247,0,0,0,.245.249ZM1.339,1.755H49.163V6.014H1.339Zm46.853.989H2.31V5.025H48.191Z",
    transform: "translate(20.249 40.64)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186267168",
    d: "M23.053.357A22.624,22.624,0,0,1,45.677,22.982a.743.743,0,0,1-.743.743H1.172a.743.743,0,0,1-.743-.743A22.625,22.625,0,0,1,23.053.357ZM38,8.035a21.138,21.138,0,0,0-36.071,14.2H44.177A21.069,21.069,0,0,0,38,8.035Z",
    transform: "translate(22.447 19.165)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186267168_-_Outline",
    "data-name": "_186267168 - Outline",
    d: "M22.6-.143A22.147,22.147,0,0,1,31.42,1.674a22.573,22.573,0,0,1,7.205,4.954,23.073,23.073,0,0,1,4.858,7.348,23.37,23.37,0,0,1,1.782,9,1.227,1.227,0,0,1-1.214,1.238H1.142A1.227,1.227,0,0,1-.071,22.976a23.37,23.37,0,0,1,1.782-9A23.072,23.072,0,0,1,6.568,6.629a22.573,22.573,0,0,1,7.205-4.954A22.147,22.147,0,0,1,22.6-.143ZM44.051,23.225a.247.247,0,0,0,.244-.249A22.209,22.209,0,0,0,37.939,7.328a21.4,21.4,0,0,0-30.686,0A22.208,22.208,0,0,0,.9,22.976a.247.247,0,0,0,.244.249ZM22.6,1.344a20.724,20.724,0,0,1,8.256,1.7A21.12,21.12,0,0,1,37.594,7.68a21.751,21.751,0,0,1,6.2,14.536l.017.512H1.382l.017-.512A21.751,21.751,0,0,1,7.6,7.679,21.12,21.12,0,0,1,14.34,3.044,20.723,20.723,0,0,1,22.6,1.344ZM42.8,21.738A20.745,20.745,0,0,0,36.909,8.379a19.963,19.963,0,0,0-28.624,0A20.745,20.745,0,0,0,2.392,21.738Z",
    transform: "translate(22.904 19.17)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186267096",
    d: "M13.718.357c3.7,0,7.019,2.594,9.39,6.789a32.8,32.8,0,0,1,3.721,15.835.743.743,0,0,1-.743.743H1.35a.743.743,0,0,1-.743-.743A32.8,32.8,0,0,1,4.328,7.146C6.7,2.952,10.016.357,13.718.357Zm8.1,7.515c-2.105-3.725-4.972-6.028-8.1-6.028s-6,2.3-8.1,6.028A30.931,30.931,0,0,0,2.1,22.238H25.335A30.934,30.934,0,0,0,21.818,7.872Z",
    transform: "translate(31.782 19.165)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186267096_-_Outline",
    "data-name": "_186267096 - Outline",
    d: "M13.712-.143A9.13,9.13,0,0,1,19.2,1.775,16.116,16.116,0,0,1,23.532,6.9a33.239,33.239,0,0,1,3.785,16.079,1.239,1.239,0,0,1-1.238,1.238H1.345A1.239,1.239,0,0,1,.107,22.976,33.237,33.237,0,0,1,3.892,6.9,16.114,16.114,0,0,1,8.225,1.775,9.13,9.13,0,0,1,13.712-.143ZM26.08,23.225a.249.249,0,0,0,.249-.249A32.243,32.243,0,0,0,22.671,7.384C20.288,3.168,17.107.846,13.712.846h0c-3.394,0-6.576,2.322-8.959,6.538A32.241,32.241,0,0,0,1.1,22.976a.249.249,0,0,0,.249.249ZM13.712,1.344a7.751,7.751,0,0,1,4.733,1.718,14.76,14.76,0,0,1,3.8,4.561,31.461,31.461,0,0,1,3.58,14.6l.01.5H1.592l.01-.5a31.459,31.459,0,0,1,3.58-14.6,14.76,14.76,0,0,1,3.8-4.561A7.751,7.751,0,0,1,13.712,1.344Zm11.11,20.394A30.188,30.188,0,0,0,21.382,8.11c-2.106-3.726-4.83-5.777-7.67-5.777S8.148,4.384,6.042,8.11A30.185,30.185,0,0,0,2.6,21.738Z",
    transform: "translate(31.788 19.17)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186267024",
    d: "M2.247.321H11.6a.743.743,0,0,1,.743.743v70.4a.743.743,0,0,1-.743.743H2.247a.743.743,0,0,1-.743-.743V1.065A.743.743,0,0,1,2.247.321Zm8.606,1.487H2.99V70.721h7.863Z",
    transform: "translate(78.166 17.297)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186267024_-_Outline",
    "data-name": "_186267024 - Outline",
    d: "M2.241-.179h9.35a1.239,1.239,0,0,1,1.238,1.238v70.4A1.239,1.239,0,0,1,11.591,72.7H2.241A1.239,1.239,0,0,1,1,71.459V1.059A1.239,1.239,0,0,1,2.241-.179Zm9.35,71.887a.249.249,0,0,0,.249-.249V1.059A.249.249,0,0,0,11.591.81H2.241a.249.249,0,0,0-.249.249v70.4a.249.249,0,0,0,.249.249Zm-9.1-70.4h8.852v69.9H2.49Zm7.863.989H3.479V70.221h6.874Z",
    transform: "translate(78.172 17.303)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266952",
    d: "M3.022,4.055H7.408V1.737H3.022ZM8.151,5.542H2.279A.743.743,0,0,1,1.536,4.8V.993A.743.743,0,0,1,2.279.25H8.151a.743.743,0,0,1,.743.743V4.8A.743.743,0,0,1,8.151,5.542Z",
    transform: "translate(79.873 13.563)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266952_-_Outline",
    "data-name": "_186266952 - Outline",
    d: "M8.146,6.031H2.274A1.239,1.239,0,0,1,1.036,4.793V.988A1.239,1.239,0,0,1,2.274-.25H8.146A1.239,1.239,0,0,1,9.383.988V4.793A1.239,1.239,0,0,1,8.146,6.031ZM2.274.739a.249.249,0,0,0-.249.249V4.793a.249.249,0,0,0,.249.249H8.146a.249.249,0,0,0,.249-.249V.988A.249.249,0,0,0,8.146.739ZM7.9,4.544H2.522V1.237H7.9ZM3.511,3.555h3.4V2.226h-3.4Z",
    transform: "translate(79.878 13.569)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266880",
    d: "M2.247.179H11.6a.743.743,0,0,1,.743.743V4.727a.743.743,0,0,1-.743.743H2.247A.743.743,0,0,1,1.5,4.727V.922A.743.743,0,0,1,2.247.179Zm8.606,1.487H2.99V3.984h7.863Z",
    transform: "translate(78.166 9.83)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266880_-_Outline",
    "data-name": "_186266880 - Outline",
    d: "M2.241-.321h9.35A1.239,1.239,0,0,1,12.828.916V4.722A1.239,1.239,0,0,1,11.591,5.96H2.241A1.239,1.239,0,0,1,1,4.722V.916A1.239,1.239,0,0,1,2.241-.321Zm9.35,5.292a.249.249,0,0,0,.249-.249V.916a.249.249,0,0,0-.249-.249H2.241a.249.249,0,0,0-.249.249V4.722a.249.249,0,0,0,.249.249ZM2.49,1.165h8.852V4.473H2.49Zm7.863.989H3.479v1.33h6.874Z",
    transform: "translate(78.172 9.835)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266808",
    d: "M3.285,9.514h3.8L5.21,3.287ZM8.08,11H2.291a.743.743,0,0,1-.721-.963h0L4.5.58A.743.743,0,0,1,5.933.53L5.221.744,5.933.531,8.779,10a.744.744,0,0,1-.7,1Z",
    transform: "translate(79.907 0.494)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266808_-_Outline",
    "data-name": "_186266808 - Outline",
    d: "M2.273,11.489a1.238,1.238,0,0,1-1.181-1.6l.144-.467h0L4.013.444A1.236,1.236,0,0,1,6.16-.06l.1-.029.128.425q.008.023.015.046l.142.473h0l2.7,8.986a1.238,1.238,0,0,1-1.168,1.647Zm-.244-1.278a.249.249,0,0,0,.172.278.243.243,0,0,0,.072.011h5.8a.249.249,0,0,0,.249-.249.245.245,0,0,0-.015-.085L8.3,10.139l-2.7-9-.239.071L5.144.5a.25.25,0,0,0-.171.183L4.963.72ZM7.741,10H2.609l2.6-8.417ZM3.95,9.014H6.411L5.2,4.977Z",
    transform: "translate(79.913 0.5)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266736",
    d: "M.743.321h9.349a.743.743,0,0,1,.743.743v70.4a.743.743,0,0,1-.743.743H.743A.743.743,0,0,1,0,71.465V1.065A.743.743,0,0,1,.743.321ZM9.349,1.808H1.487V70.721H9.349Z",
    transform: "translate(0.494 17.297)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266736_-_Outline",
    "data-name": "_186266736 - Outline",
    d: "M.738-.179h9.349a1.239,1.239,0,0,1,1.238,1.238v70.4A1.239,1.239,0,0,1,10.087,72.7H.738A1.239,1.239,0,0,1-.5,71.459V1.059A1.239,1.239,0,0,1,.738-.179Zm9.349,71.887a.249.249,0,0,0,.249-.249V1.059A.249.249,0,0,0,10.087.81H.738a.249.249,0,0,0-.249.249v70.4a.249.249,0,0,0,.249.249Zm-9.1-70.4H9.838v69.9H.987ZM8.849,2.3H1.975V70.221H8.849Z",
    transform: "translate(0.5 17.303)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266664",
    d: "M1.519,4.055H5.9V1.737H1.519ZM6.648,5.542H.776A.743.743,0,0,1,.033,4.8V.993A.743.743,0,0,1,.776.25H6.648a.743.743,0,0,1,.743.743V4.8A.743.743,0,0,1,6.648,5.542Z",
    transform: "translate(2.2 13.563)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266664_-_Outline",
    "data-name": "_186266664 - Outline",
    d: "M6.642,6.031H.77A1.239,1.239,0,0,1-.467,4.793V.988A1.239,1.239,0,0,1,.77-.25H6.642A1.239,1.239,0,0,1,7.88.988V4.793A1.239,1.239,0,0,1,6.642,6.031ZM.77.739A.249.249,0,0,0,.522.988V4.793a.249.249,0,0,0,.249.249H6.642a.249.249,0,0,0,.249-.249V.988A.249.249,0,0,0,6.642.739ZM6.394,4.544H1.019V1.237H6.394ZM2.008,3.555H5.4V2.226h-3.4Z",
    transform: "translate(2.206 13.569)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266592",
    d: "M.743.179h9.349a.743.743,0,0,1,.743.743V4.727a.743.743,0,0,1-.743.743H.743A.743.743,0,0,1,0,4.727V.922A.743.743,0,0,1,.743.179ZM9.349,1.665H1.487V3.984H9.349Z",
    transform: "translate(0.494 9.83)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266592_-_Outline",
    "data-name": "_186266592 - Outline",
    d: "M.738-.321h9.349A1.239,1.239,0,0,1,11.325.916V4.722A1.239,1.239,0,0,1,10.087,5.96H.738A1.239,1.239,0,0,1-.5,4.722V.916A1.239,1.239,0,0,1,.738-.321Zm9.349,5.292a.249.249,0,0,0,.249-.249V.916a.249.249,0,0,0-.249-.249H.738A.249.249,0,0,0,.489.916V4.722a.249.249,0,0,0,.249.249ZM.987,1.165H9.838V4.473H.987Zm7.863.989H1.975v1.33H8.849Z",
    transform: "translate(0.5 9.835)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266520",
    d: "M1.782,9.514h3.8L3.707,3.287ZM6.577,11H.787a.743.743,0,0,1-.721-.963h0L2.993.58A.743.743,0,0,1,4.43.53L3.718.744,4.429.531,7.276,10a.744.744,0,0,1-.7,1Z",
    transform: "translate(2.236 0.494)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266520_-_Outline",
    "data-name": "_186266520 - Outline",
    d: "M.77,11.489a1.238,1.238,0,0,1-1.181-1.6l.144-.467h0L2.51.444a1.236,1.236,0,0,1,2.147-.5l.1-.029.126.421q.009.025.016.05L5.04.855h0l2.7,8.987a1.238,1.238,0,0,1-1.168,1.647ZM.526,10.21a.249.249,0,0,0,.172.279A.245.245,0,0,0,.77,10.5h5.8a.249.249,0,0,0,.234-.335L6.8,10.139l-2.7-9-.239.071L3.64.5a.25.25,0,0,0-.171.184L3.46.72ZM6.238,10H1.106l2.6-8.417ZM2.447,9.014H4.908L3.7,4.977Z",
    transform: "translate(2.241 0.5)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266448",
    d: "M7.263,1.143a7.019,7.019,0,0,1,7,7v20.38a.743.743,0,0,1-.743.743H1.006a.743.743,0,0,1-.743-.743V8.144a7.019,7.019,0,0,1,7-7Zm0,1.486A5.532,5.532,0,0,0,1.749,8.143V27.781H12.777V8.143A5.532,5.532,0,0,0,7.263,2.63Z",
    transform: "translate(14.04 60.238)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266448_-_Outline",
    "data-name": "_186266448 - Outline",
    d: "M7.257.643a7.513,7.513,0,0,1,7.495,7.495v20.38a1.239,1.239,0,0,1-1.238,1.238H1A1.239,1.239,0,0,1-.238,28.518V8.138A7.513,7.513,0,0,1,7.257.643Zm6.257,28.124a.249.249,0,0,0,.249-.249V8.138a6.5,6.5,0,0,0-11.1-4.6,6.461,6.461,0,0,0-1.911,4.6v20.38A.249.249,0,0,0,1,28.767ZM7.257,2.129a6.027,6.027,0,0,1,6.008,6.008V28.27H1.249V8.138A6.027,6.027,0,0,1,7.257,2.129Zm5.02,25.151V8.138A5.012,5.012,0,0,0,3.713,4.594,4.983,4.983,0,0,0,2.238,8.138V27.281Z",
    transform: "translate(14.05 60.244)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266376",
    d: "M7.569,1.143a7.019,7.019,0,0,1,7,7v20.38a.743.743,0,0,1-.743.743H1.312a.743.743,0,0,1-.743-.743V8.144a7.019,7.019,0,0,1,7-7Zm0,1.486A5.532,5.532,0,0,0,2.055,8.143V27.781H13.083V8.143A5.532,5.532,0,0,0,7.569,2.63Z",
    transform: "translate(29.865 60.238)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266376_-_Outline",
    "data-name": "_186266376 - Outline",
    d: "M7.564.643a7.513,7.513,0,0,1,7.495,7.495v20.38a1.239,1.239,0,0,1-1.238,1.238H1.306A1.239,1.239,0,0,1,.069,28.518V8.138A7.514,7.514,0,0,1,7.564.643Zm6.257,28.124a.249.249,0,0,0,.249-.249V8.138a6.5,6.5,0,0,0-11.1-4.6,6.461,6.461,0,0,0-1.911,4.6v20.38a.249.249,0,0,0,.249.249ZM7.564,2.129a6.027,6.027,0,0,1,6.008,6.008V28.27H1.555V8.138A6.027,6.027,0,0,1,7.564,2.129Zm5.02,25.151V8.138a5.02,5.02,0,0,0-10.039,0V27.281Z",
    transform: "translate(29.872 60.244)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266304",
    d: "M7.876,1.143h0a7.019,7.019,0,0,1,7,7v20.38a.743.743,0,0,1-.743.743H1.618a.743.743,0,0,1-.743-.743V8.144a7.019,7.019,0,0,1,7-7Zm0,1.486h0A5.532,5.532,0,0,0,2.362,8.143V27.781H13.39V8.143A5.532,5.532,0,0,0,7.876,2.63Z",
    transform: "translate(45.69 60.238)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266304_-_Outline",
    "data-name": "_186266304 - Outline",
    d: "M7.87.643h0a7.513,7.513,0,0,1,7.495,7.495v20.38a1.239,1.239,0,0,1-1.238,1.238H1.613A1.239,1.239,0,0,1,.375,28.518V8.138A7.513,7.513,0,0,1,7.87.643Zm6.257,28.124a.249.249,0,0,0,.249-.249V8.138A6.525,6.525,0,0,0,7.87,1.632h0A6.525,6.525,0,0,0,1.364,8.138v20.38a.249.249,0,0,0,.249.249ZM7.87,2.129a6.026,6.026,0,0,1,6.008,6.008V28.27H1.862V8.138A6.027,6.027,0,0,1,7.87,2.129Zm5.02,25.151V8.138a5.02,5.02,0,0,0-10.039,0V27.281Z",
    transform: "translate(45.694 60.244)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266256",
    d: "M8.182,1.143h0a7.019,7.019,0,0,1,7,7v20.38a.743.743,0,0,1-.743.743H1.925a.743.743,0,0,1-.743-.743V8.144a7.019,7.019,0,0,1,7-7Zm0,1.486h0A5.532,5.532,0,0,0,2.668,8.143V27.781H13.7V8.143A5.532,5.532,0,0,0,8.182,2.63Z",
    transform: "translate(61.514 60.238)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266256_-_Outline",
    "data-name": "_186266256 - Outline",
    d: "M8.176.643h0a7.513,7.513,0,0,1,7.495,7.495v20.38a1.239,1.239,0,0,1-1.238,1.238H1.919A1.239,1.239,0,0,1,.681,28.518V8.138A7.513,7.513,0,0,1,8.176.643Zm6.257,28.124a.249.249,0,0,0,.249-.249V8.138A6.525,6.525,0,0,0,8.177,1.632h0A6.525,6.525,0,0,0,1.67,8.138v20.38a.249.249,0,0,0,.249.249ZM8.176,2.129a6.027,6.027,0,0,1,6.009,6.008V28.27H2.168V8.138A6.027,6.027,0,0,1,8.176,2.129ZM13.2,27.281V8.138a5.02,5.02,0,0,0-10.039,0V27.281Z",
    transform: "translate(61.516 60.244)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266136",
    d: "M.909.857H70.754a.739.739,0,0,1,.734.743V5.406a.739.739,0,0,1-.734.743H.909a.739.739,0,0,1-.734-.743V1.6A.739.739,0,0,1,.909.857ZM70.02,2.344H1.643V4.663H70.02Z",
    transform: "translate(9.668 45.302)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266136_-_Outline",
    "data-name": "_186266136 - Outline",
    d: "M.9.357H70.754a1.232,1.232,0,0,1,1.222,1.238V5.4a1.232,1.232,0,0,1-1.222,1.238H.9A1.232,1.232,0,0,1-.324,5.4V1.595A1.232,1.232,0,0,1,.9.357ZM70.754,5.649A.248.248,0,0,0,71,5.4V1.595a.248.248,0,0,0-.246-.249H.9a.248.248,0,0,0-.246.249V5.4A.248.248,0,0,0,.9,5.649ZM1.144,1.844H70.508V5.152H1.144Zm68.388.989H2.12v1.33H69.532Z",
    transform: "translate(9.674 45.308)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266064",
    d: "M1.96.429c-.249,0-.45.333-.45.743s.2.743.45.743h9.229c.249,0,.451-.333.451-.743s-.2-.743-.451-.743Z",
    transform: "translate(78.512 22.898)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186266064_-_Outline",
    "data-name": "_186266064 - Outline",
    d: "M1.955-.071h9.229c.539,0,.945.532.945,1.238S11.722,2.4,11.183,2.4H1.955c-.539,0-.945-.532-.945-1.238S1.416-.071,1.955-.071Zm9.136.989H2.048A.593.593,0,0,0,2,1.166a.593.593,0,0,0,.049.249h9.043a.592.592,0,0,0,.049-.249A.593.593,0,0,0,11.091.918Z",
    transform: "translate(78.518 22.904)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265992",
    d: "M1.96.5c-.249,0-.45.333-.45.743s.2.743.45.743h9.229c.249,0,.451-.333.451-.743S11.438.5,11.189.5Z",
    transform: "translate(78.512 26.632)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265992_-_Outline",
    "data-name": "_186265992 - Outline",
    d: "M1.955,0h9.229c.539,0,.945.532.945,1.238s-.406,1.238-.945,1.238H1.955c-.539,0-.945-.532-.945-1.238S1.416,0,1.955,0Zm9.136.989H2.048A.593.593,0,0,0,2,1.238a.593.593,0,0,0,.049.249h9.043a.592.592,0,0,0,.049-.249A.592.592,0,0,0,11.091.989Z",
    transform: "translate(78.518 26.638)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265920",
    d: "M.457.429c-.249,0-.451.333-.451.743s.2.743.451.743H9.686c.249,0,.451-.333.451-.743s-.2-.743-.451-.743Z",
    transform: "translate(0.841 22.898)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265920_-_Outline",
    "data-name": "_186265920 - Outline",
    d: "M.452-.071H9.68c.539,0,.945.532.945,1.238S10.219,2.4,9.68,2.4H.452c-.539,0-.945-.532-.945-1.238S-.087-.071.452-.071ZM9.587.918H.545A.593.593,0,0,0,.5,1.166a.592.592,0,0,0,.049.249H9.587a.592.592,0,0,0,.049-.249A.592.592,0,0,0,9.587.918Z",
    transform: "translate(0.846 22.904)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265848",
    d: "M.457.5C.208.5.007.833.007,1.243s.2.743.451.743H9.686c.249,0,.451-.333.451-.743S9.935.5,9.686.5Z",
    transform: "translate(0.841 26.632)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265848_-_Outline",
    "data-name": "_186265848 - Outline",
    d: "M.452,0H9.68c.539,0,.945.532.945,1.238s-.406,1.238-.945,1.238H.452c-.539,0-.945-.532-.945-1.238S-.087,0,.452,0ZM9.587.989H.545A.592.592,0,0,0,.5,1.238a.592.592,0,0,0,.049.249H9.587a.592.592,0,0,0,.049-.249A.592.592,0,0,0,9.587.989Z",
    transform: "translate(0.846 26.638)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265776",
    d: "M2.326.966a.743.743,0,1,0-1.487,0v7.15a.743.743,0,1,0,1.487,0Z",
    transform: "translate(43.917 12.149)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265776_-_Outline",
    "data-name": "_186265776 - Outline",
    d: "M1.577-.277A1.239,1.239,0,0,1,2.815.961v7.15a1.238,1.238,0,0,1-2.475,0V.961A1.239,1.239,0,0,1,1.577-.277Zm0,8.636a.249.249,0,0,0,.249-.249V.961a.249.249,0,0,0-.5,0v7.15A.249.249,0,0,0,1.577,8.359Z",
    transform: "translate(43.923 12.154)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265704",
    d: "M8.831,4.8a.74.74,0,0,0-1.283-.737A2.83,2.83,0,0,1,3.688,5.1l-.372.642L3.688,5.1c-.018-.01-.036-.02-.054-.028a2.83,2.83,0,0,1-.982-3.83A.742.742,0,1,0,1.369.495,4.3,4.3,0,0,0,2.879,6.341a.735.735,0,0,0,.065.042h0A4.305,4.305,0,0,0,8.831,4.8Z",
    transform: "translate(41.302 7.025)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265704_-_Outline",
    "data-name": "_186265704 - Outline",
    d: "M5.092,7.45a4.8,4.8,0,0,1-1.96-.42l-.014.024L2.69,6.805c-.032-.019-.061-.037-.088-.056A4.8,4.8,0,0,1,.935.242,1.236,1.236,0,0,1,2.624-.208a1.236,1.236,0,0,1,.45,1.689,2.336,2.336,0,0,0,.782,3.142l.016.009.059.032L4,4.7a2.324,2.324,0,0,0,1.092.274A2.35,2.35,0,0,0,5.7,4.9,2.314,2.314,0,0,0,7.114,3.813a1.235,1.235,0,0,1,2.14,1.231A4.773,4.773,0,0,1,6.337,7.285,4.812,4.812,0,0,1,5.092,7.45ZM3.162,5.934l.025.014A3.811,3.811,0,0,0,8.4,4.55a.246.246,0,0,0-.213-.367.247.247,0,0,0-.213.123A3.3,3.3,0,0,1,5.954,5.851a3.34,3.34,0,0,1-.864.114,3.31,3.31,0,0,1-1.209-.229l-.143.246-.856-.5.141-.244A3.327,3.327,0,0,1,2.218.986.247.247,0,0,0,2.129.647a.247.247,0,0,0-.338.09A3.81,3.81,0,0,0,3.129,5.912Z",
    transform: "translate(41.307 7.03)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265632",
    d: "M3.582,2.475a1.768,1.768,0,1,0,1.25.518A1.763,1.763,0,0,0,3.582,2.475Zm-2.3-.533a3.254,3.254,0,1,1-.953,2.3,3.244,3.244,0,0,1,.953-2.3Z",
    transform: "translate(17.406 52.173)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265632_-_Outline",
    "data-name": "_186265632 - Outline",
    d: "M3.576.489a3.749,3.749,0,0,1,2.651,6.4,3.749,3.749,0,1,1-5.3-5.3A3.724,3.724,0,0,1,3.576.489ZM3.576,7a2.761,2.761,0,1,0-1.952-.809A2.741,2.741,0,0,0,3.576,7Zm0-5.023a2.262,2.262,0,1,1-1.6.663A2.248,2.248,0,0,1,3.576,1.975Zm0,3.536a1.273,1.273,0,1,0-.9-.373A1.265,1.265,0,0,0,3.576,5.511Z",
    transform: "translate(17.415 52.179)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265560",
    d: "M3.892,2.475a1.768,1.768,0,1,0,1.25.518A1.763,1.763,0,0,0,3.892,2.475Zm-2.3-.533a3.254,3.254,0,1,1-.953,2.3A3.244,3.244,0,0,1,1.59,1.942Z",
    transform: "translate(33.438 52.173)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265560_-_Outline",
    "data-name": "_186265560 - Outline",
    d: "M3.886.489a3.749,3.749,0,0,1,2.651,6.4,3.749,3.749,0,1,1-5.3-5.3A3.724,3.724,0,0,1,3.886.489ZM3.886,7a2.76,2.76,0,1,0-1.952-.809A2.742,2.742,0,0,0,3.886,7Zm0-5.023a2.262,2.262,0,1,1-1.6.663A2.248,2.248,0,0,1,3.886,1.975Zm0,3.536a1.273,1.273,0,1,0-.9-.373A1.265,1.265,0,0,0,3.886,5.511Z",
    transform: "translate(33.444 52.179)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265464",
    d: "M4.2,2.475a1.768,1.768,0,1,0,1.25.518A1.763,1.763,0,0,0,4.2,2.475ZM1.9,1.942a3.254,3.254,0,1,1-.953,2.3A3.245,3.245,0,0,1,1.9,1.942Z",
    transform: "translate(49.469 52.173)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265464_-_Outline",
    "data-name": "_186265464 - Outline",
    d: "M4.2.489a3.749,3.749,0,0,1,2.651,6.4,3.749,3.749,0,1,1-5.3-5.3A3.724,3.724,0,0,1,4.2.489ZM4.2,7a2.76,2.76,0,1,0-1.952-.809A2.741,2.741,0,0,0,4.2,7Zm0-5.023a2.262,2.262,0,1,1-1.6.663A2.248,2.248,0,0,1,4.2,1.975Zm0,3.536a1.273,1.273,0,1,0-.9-.373A1.265,1.265,0,0,0,4.2,5.511Z",
    transform: "translate(49.473 52.179)",
    fill: "#00621e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265416",
    d: "M4.512,2.475a1.768,1.768,0,1,0,1.25.518A1.763,1.763,0,0,0,4.512,2.475Zm-2.3-.533a3.254,3.254,0,1,1-.953,2.3A3.244,3.244,0,0,1,2.211,1.942Z",
    transform: "translate(65.5 52.173)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_186265416_-_Outline",
    "data-name": "_186265416 - Outline",
    d: "M4.506.489a3.749,3.749,0,0,1,2.651,6.4,3.749,3.749,0,1,1-5.3-5.3A3.723,3.723,0,0,1,4.506.489ZM4.506,7a2.761,2.761,0,1,0-1.951-.809A2.741,2.741,0,0,0,4.506,7Zm0-5.023a2.262,2.262,0,1,1-1.6.663A2.248,2.248,0,0,1,4.506,1.975Zm0,3.536a1.273,1.273,0,1,0-.9-.373A1.265,1.265,0,0,0,4.506,5.511Z",
    transform: "translate(65.502 52.179)",
    fill: "#00621e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicEndowment);
export default __webpack_public_path__ + "static/media/publicEndowment.0f6a29030156fb8479d13c889d3bfad4.svg";
export { ForwardRef as ReactComponent };